import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 31,
	height: 52,
	viewBox: "0 0 31 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.22696 50.3512C0.443489 48.5571 0.448612 45.6579 2.23841 43.8701L16.4773 29.6469C18.431 27.6954 18.4328 24.5295 16.4812 22.5758L2.2331 8.31237C0.447517 6.52486 0.449093 3.62829 2.23662 1.84273C4.02274 0.0585777 6.91653 0.0585771 8.70265 1.84273L29.4586 22.5758C31.4138 24.5289 31.4138 27.6977 29.4586 29.6508L8.72382 50.3627C6.92786 52.1567 4.01656 52.1515 2.22696 50.3512Z",
		fill: "currentColor"
	})
});
export default SvgIcRightArrow;
